// extracted by mini-css-extract-plugin
module.exports = {"flex-center":"BookingBlock_flex-center_10fwf","sort-group":"BookingBlock_sort-group_28DYO"};